import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UrlTrackerService {
  private prevUrl: string;

  get previousUrl(): string {
    return this.prevUrl;
  }

  constructor(private router: Router) {}

  trackPreviousUrl() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.prevUrl = e.url;
      }
    });
  }
}
